import { useContext, useRef } from "react";

import { CreatePostModalContext } from "../..";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../../redux";
import { validAudioFileTypes } from "../../../../../../../../utils";
import AudioMeta from "./AudioMeta";
import AudioPreview from "./AudioPreview";
import AudioUpload from "./AudioUpload";
import { HiddenInput } from "./style";

const Audio = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { post_id } = useAppSelector((state) => state.posts);
  const { uploadedAudio, audio_id } = useAppSelector(
    (state) => state.postAudio
  );
  const { selectedCollaborator } = useContext(CreatePostModalContext);

  return (
    <>
      {uploadedAudio?.audio_path ? (
        <>
          <AudioMeta />
          <AudioPreview selectedCollaborator={selectedCollaborator} />
        </>
      ) : (
        <AudioUpload fileInputRef={fileInputRef} />
      )}
      <HiddenInput
        type="file"
        onChange={(e) => {
          const files = e.target.files;
          if (files?.length) {
            API_CALLS.POSTAUDIO.uploadAudioToAPost({
              audioFile: files[0],
              post_id,
              content_id: audio_id,
            });
          }
        }}
        ref={fileInputRef}
        id="image-upload"
        accept={validAudioFileTypes.join(",")}
      />
    </>
  );
};

export default Audio;
